<template>
    <div class="realtime">
        <!-- 设备状态 -->
        <van-notice-bar left-icon="volume-o">
            <span style='color: #7CFC00' class="insWorkDesc">仪器正常数：</span>
            <span style='color: #7CFC00' class="insWorkNum">{{startWorkNum}}</span>
            <span style='color: #FFA500' class="insWorkDesc">仪器故障数：</span>
            <span style='color: #FFA500' class="insWorkNum">{{faultWorkNum}}</span>
            <span style='color: #FF0000' class="insWorkDesc">仪器离线数：</span>
            <span style='color: #FF0000' class="insWorkNum">{{stopWorkNum}}</span>
        </van-notice-bar>
        <!-- 地图 -->
        <div class="baiduMap" id="mapContent"></div>
    </div>
</template>

<script>
    import echarts from 'echarts'
    import $ from 'jquery'
    import greenImg from '../assets/img/marker_8.png';
    import yellowImg from '../assets/img/marker_7.png';
    import redImg from '../assets/img/marker_6.png';
    export default {
        name: '',
        data () {
            return {
                bmap:null,
                markerArr:[],
                startWorkNum:0,
                stopWorkNum:0,
                faultWorkNum:0,
                chooseIns:'',
                ak:'xVImWZpmsVli9X3O9OTNfRWL8DdKBbZq',
                siteLoading:null,
                chartLoading:null,
            }
        },
        methods: {
            //初始化百度地图
            initBMap(){
                let _this=this;
                _this.siteLoading=_this.$toast.loading({
                    duration:0,
                    mask: true,
                    message: '初始化站点中...'
                });
                _this.bmap = new BMap.Map('mapContent',{enableMapClick:true});    // 创建Map实例
                _this.bmap.centerAndZoom(new BMap.Point(116.27,40.53), 11);  // 初始化地图,设置中心点坐标和地图级别
                _this.bmap.setMaxZoom(15);
                _this.bmap.setMinZoom(5);
                //添加地图类型控件
                _this.bmap.addControl(new BMap.MapTypeControl({
                    mapTypes:[
                        BMAP_NORMAL_MAP,
                        BMAP_HYBRID_MAP
                    ]
                }));
                //_this.bmap.setCurrentCity("北京");
                _this.bmap.enableScrollWheelZoom(true);     //开启鼠标滚轮缩放
                _this.bmap.enableDragging(true);    //开启拖拽
                if (this._isMobile()) {
                    _this.bmap.addEventListener("touchstart",_this.markerClick);
                } else {
                    _this.bmap.addEventListener("click",_this.markerClick);
                }
                _this.initSiteData();
            },
            //初始化站点
            initSiteData(){
                let _this=this;
                let localSite=sessionStorage.getItem('powerData');
                if(localSite){
                    let localObj=eval('('+localSite+')');
                    if(typeof localObj === "object"){
                        _this.siteLoading.clear();
                        _this.$toast.success({
                            duration:500,
                            mask:true,
                            message:'站点加载完成'
                        });
                        _this.startWorkNum=localObj.OnlineCount;
                        _this.stopWorkNum=localObj.OffLineCount;
                        _this.faultWorkNum=localObj.BreakdownCount;
                        _this.addMapMarker(localObj.SiteResumes);
                    }
                }
            },
            //加载地图点位
            addMapMarker(siteData){
                let _this=this;
                let greenIcon = new BMap.Icon(greenImg, new BMap.Size(25, 50));
                let yellowIcon = new BMap.Icon(yellowImg, new BMap.Size(25, 50));
                let redIcon = new BMap.Icon(redImg, new BMap.Size(25, 50));
                for (let i = 0; i < siteData.length; i ++) {
                    //添加marker---计算仪器工作及停止数量
                    let lng=siteData[i].Site.lng;
                    let lat=siteData[i].Site.lat;
                    let Status=siteData[i].Instruments[0].status;
                    let point = new BMap.Point(lng,lat);
                    let markerIcon=null;
                    if(Status === 1){  //正常
                        markerIcon=greenIcon;
                    }else if(Status === 0){   //离线
                        markerIcon=redIcon;
                    }else if(Status === -1){   //故障
                        markerIcon=yellowIcon;
                    }
                    let marker = new BMap.Marker(point,{icon:markerIcon});
                    marker.parameter=siteData[i];
                    let siteLength=siteData[i].Site.name.length;
                    let label = new BMap.Label(siteData[i].Site.name,{offset:new BMap.Size(-6*siteLength,-23)});
                    label.setStyle({border:"1px solid #FFF",background:"rgba(0,0,0,0.7)",'border-radius':'8px',color:'#FFF','line-height':'20px',padding:'0 10px'});
                    marker.setLabel(label);
                    _this.bmap.addOverlay(marker);
                    _this.markerArr.push(point);
                }
                _this.bmap.setViewport(_this.markerArr);
            },
            //地图点击事件
            markerClick(e){
                let _this=this;
                let overlay=e.overlay;
                if(overlay !== null){
                    // _this.chartLoading=_this.$toast.loading({
                    //     duration:0,
                    //     mask: true,
                    //     message: '加载中...'
                    // });
                    sessionStorage.setItem("realTimeIns",JSON.stringify(overlay.parameter));
                    console.log(overlay);
                    _this.$router.push('/History');
                }
            },
            //设置主体位置高度
            setMapHeight(){
                let homeHeight=$(".realtime").height();
                let tabbarHeight=$(".van-notice-bar").height();
                $(".baiduMap").height(homeHeight-tabbarHeight);
            },
            //判断运行环境
            _isMobile() {
                let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
                return flag;
            },
        },
        mounted() {
            setTimeout(()=>{
                this.setMapHeight();
            },400);
            this.$nextTick(function() {
                setTimeout(()=>{
                    this.initBMap();
                },800);
            });
        },
        beforeDestroy(){
            
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    @import "../style/realtime.css";
    @import "../style/bottomanimate.css";
</style>



// WEBPACK FOOTER //
// src/components/RealTime.vue